import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import Section, { SectionHeading } from "@/components/Section";

const SERVICES = [
  "Catalog readiness",
  "SKU planning",
  "Packaging readiness",
  "Platform coordination support",
  "RO/PO tracking",
  "Inventory planning",
  "Replenishment planning",
  "Dark store supply planning",
  "Ad spend tracking",
  "Sales reporting",
  "Marketplace performance monitoring",
];

export default function MarketplaceManagement() {
  return (
    <Section id="marketplace" bg="soft">
      <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10">
        <div>
          <SectionHeading
            eyebrow="For FMCG & D2C Brands"
            title={<>Helping brands scale on <span className="text-[#99CC00]">quick commerce.</span></>}
            sub="For FMCG and D2C brands looking to build a stronger operational presence across QC marketplaces like Blinkit, Instamart, Zepto and more."
          />
          <div className="mt-8 rounded-3xl bg-white p-6 text-sm leading-6 text-neutral-600 shadow-sm border border-neutral-200">
            We support brands in <span className="font-black text-[#1F1F1F]">preparing, managing and scaling</span> their QC marketplace operations. Platform listing approval remains subject to each marketplace’s own process.
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 lg:gap-4">
          {SERVICES.map((item, i) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              data-testid={`marketplace-service-${i}`}
              className="rounded-2xl bg-white p-4 lg:p-5 shadow-sm border border-neutral-200 hover:-translate-y-0.5 hover:shadow-lg hover:border-[#99CC00]/40 transition"
            >
              <CheckCircle2 className="mb-3 h-5 w-5 text-[#99CC00]" />
              <div className="text-sm font-black leading-5 text-[#1F1F1F]">{item}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </Section>
  );
}
